/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindLeadsBatchWithCommentCountsRequest
 */
export interface FindLeadsBatchWithCommentCountsRequest {
    /**
     * 
     */
    lead_ids: Set<string>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithCommentCountsRequest interface.
 */
export function instanceOfFindLeadsBatchWithCommentCountsRequest(value: object): value is FindLeadsBatchWithCommentCountsRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    return true;
}

export function FindLeadsBatchWithCommentCountsRequestFromJSON(json: any): FindLeadsBatchWithCommentCountsRequest {
    return FindLeadsBatchWithCommentCountsRequestFromJSONTyped(json, false);
}

export function FindLeadsBatchWithCommentCountsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithCommentCountsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': new Set(json['lead_ids']),
    };
}

export function FindLeadsBatchWithCommentCountsRequestToJSON(json: any): FindLeadsBatchWithCommentCountsRequest {
    return FindLeadsBatchWithCommentCountsRequestToJSONTyped(json, false);
}

export function FindLeadsBatchWithCommentCountsRequestToJSONTyped(value?: FindLeadsBatchWithCommentCountsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': Array.from(value['lead_ids'] as Set<any>),
    };
}

